module.exports = __webpack_public_path__ + "static/media/centreFormation.f1b4e0ff.png";